import React from "react";
import { Box, Typography, Grid, Paper, Avatar } from "@mui/material";

const tools = [
    {
        img: "/assets/my-family-10.png",
        title: "Tool 10: My Special Family",
        desc: "Helps children appreciate the uniqueness and love within their family.",
    },
    {
        img: "/assets/my-family-11.png",
        title: "Tool 11: “Our Family Fun List” Poster",
        desc: "Inspires families to plan joyful and bonding activities together.",
    },
    {
        img: "/assets/my-family-12.png",
        title: "Tool 12: Family Rituals",
        desc: "Encourages creating small, meaningful traditions that strengthen connection.",
    },
    {
        img: "/assets/my-family-13.png",
        title: "Tool 13: Family Bucket-list",
        desc: "A shared list of dreams and adventures to experience as a family.",
    },
    {
        img: "/assets/my-family-14.png",
        title: "Tool 14: Family Rules",
        desc: "Guides families to agree on shared values and respectful household behaviors.",
    },
    {
        img: "/assets/my-family-15.png",
        title: "Tool 15: Weekly Family Meeting",
        desc: "Builds open communication and teamwork through regular check-ins.",
    },
    {
        img: "/assets/my-family-16.png",
        title: "Tool 16: Family Treasure Box",
        desc: "A keepsake for storing special memories, notes, or gratitude moments.",
    },
];

const letterToParents = {
    img: "/assets/my-family-letter.png",
    title: "A Letter to Parents",
    desc:
        "Your little family-this precious circle of love-is your everything. It’s where laughter lives, where lessons are learned, and where love grows stronger every day.",
};

export default function BookChapterMyFamily() {
    return (
        <Box maxWidth="1120px" mx="auto" p={3} display="flex" flexDirection="column" alignItems="center">
            <Typography
                variant="h3"
                
                fontWeight={400}
                gutterBottom
                sx={{ mb: 4, textAlign: "center" }}
            >
                <strong>Book Chapter My Family</strong>
            </Typography>
            <Grid container spacing={4} justifyContent="center">
                {tools.map((tool, idx) => (
                    <Grid item xs={12} sm={6} key={tool.title} display="flex" justifyContent="center">
                        <Paper elevation={2} sx={{ display: "flex", p: 2, alignItems: "flex-start" }}>
                            <Avatar
                                src={tool.img}
                                alt={tool.title}
                                sx={{ width: 66, height: 66, mr: 2, bgcolor: "transparent" }}
                                variant="square"
                            />
                            <Box>
                                <Typography
                                    variant="h5"
                                    
                                    fontWeight={400}
                                    gutterBottom
                                >
                                    <strong>{tool.title}</strong>
                                </Typography>
                                <Typography variant="body1" fontSize={20}>
                                    {tool.desc}
                                </Typography>
                            </Box>
                        </Paper>
                    </Grid>
                ))}
                <Grid item xs={12} sm={6} display="flex" justifyContent="center">
                    <Paper elevation={2} sx={{ display: "flex", p: 2, alignItems: "flex-start" }}>
                        <Avatar
                            src={letterToParents.img}
                            alt={letterToParents.title}
                            sx={{ width: 66, height: 66, mr: 2, bgcolor: "transparent" }}
                            variant="square"
                        />
                        <Box>
                            <Typography
                                variant="h5"
                                
                                fontWeight={400}
                                gutterBottom
                            >
                                <strong>{letterToParents.title}</strong>
                            </Typography>
                            <Typography variant="body1" fontSize={19}>
                                {letterToParents.desc}
                            </Typography>
                        </Box>
                    </Paper>
                </Grid>
            </Grid>
        </Box>
    );
}